/**
 * Formats a given collection to the standard redux likes
 * @param collection The collection to format
 * @param keyProp A key that is present in the collection's designated type
 * @param compareKeyOrFunc A key that is in the collection's designated type (has to be number) or a compare function that compare two collection's designated type
 */
export function normalizeForRedux(collection, keyProp, compareKeyOrFunc) {
    const byIdData = normalizeToKeyValue(collection, keyProp);
    if (Object.keys(byIdData).length === 0) {
        return { byId: {}, allIds: new Array() };
    }
    let compareFunc = typeof compareKeyOrFunc == 'function'
        ? compareKeyOrFunc
        : (a, b) => a[compareKeyOrFunc] - b[compareKeyOrFunc];
    const allIds = compareKeyOrFunc
        ? getAllIdsWithSorting(byIdData, keyProp, compareFunc)
        : collection.map(e => e[keyProp]);
    return {
        byId: Object.assign({}, byIdData),
        // TS states this must be string if it's number and number if it's string. Not much I can do about that.
        // @ts-ignore
        allIds
    };
}
/**
 * Formats a given normalizedCollection back to the collection array
 * @param normalizedCollection The collection to format
 */
export function deNormalizeFromRedux(normalizedCollection) {
    return Object.values(normalizedCollection.byId);
}
/**
 * Formats a given collection to the key value
 * @param collection The collection to format
 * @param keyProp A key that is present in the collection's designated type
 */
export function normalizeToKeyValue(collection, keyProp) {
    if (!collection || collection.length === 0 || !keyProp) {
        return {};
    }
    const byIdData = collection.reduce((result, element) => {
        // TS states this must be string or number, which is true, but I'd rather enforce that the key exists on the entity
        // type and I can't do both with TypeScript
        // @ts-ignore
        result[element[keyProp]] = element;
        return result;
    }, {});
    return byIdData;
}
export function convertMapToNormalizedCollection(map) {
    const collection = createEmptyNormalizedCollection();
    for (let key of Array.from(map.keys())) {
        collection.allIds.push(key);
        collection.byId = Object.assign(Object.assign({}, collection.byId), { [key]: map.get(key) });
    }
    return collection;
}
export const createEmptyNormalizedCollection = function () {
    return getEmptyNormalizedCollection();
};
export const resetNormalizedCollection = function () {
    return getEmptyNormalizedCollection();
};
function getEmptyNormalizedCollection() {
    return {
        byId: {},
        allIds: []
    };
}
function getAllIdsWithSorting(entity, keyProp, compareFunc) {
    return Object.values(entity)
        .sort(compareFunc)
        .map(a => a[keyProp]);
}
//# sourceMappingURL=Normalizer.js.map